export default defineNuxtPlugin(() => {
  return {
    provide: {
      clickskeksConsent: {
        getObject() {
          const consentStorage = import.meta.client ? localStorage.getItem('ucData') : undefined
          return JSON.parse(consentStorage || '{}')
        },
      },
    },
  }
})
